/**
 * Codigos de error
 */
export const RESET_PASSWORD_PENDING = "RESET_PASSWORD_PENDING";
export const RESET_PASSWORD_MODE = "RESET_PASSWORD_MODE";
export const USER_OUT_OF_SCHEDULE = "USER_OUT_OF_SCHEDULE";
export const USER_NOT_ACTIVE = "USER_NOT_ACTIVE";
